export const FETCH_REQUEST = "MENU_ITEMS/FETCH_REQUEST";
export const FETCH_SUCCESS = "MENU_ITEMS/FETCH_SUCCESS";
export const FETCH_FAILED = "MENU_ITEMS/FETCH_FAILED";

export const CREATE_REQUEST = "MENU_ITEMS/CREATE_REQUEST";
export const CREATE_SUCCESS = "MENU_ITEMS/CREATE_SUCCESS";
export const CREATE_FAILED = "MENU_ITEMS/CREATE_FAILED";

export const UPDATE_REQUEST = "MENU_ITEMS/UPDATE_REQUEST";
export const UPDATE_SUCCESS = "MENU_ITEMS/UPDATE_SUCCESS";
export const UPDATE_FAILED = "MENU_ITEMS/UPDATE_FAILED";

export const DELETE_REQUEST = "MENU_ITEMS/DELETE_REQUEST";
export const DELETE_SUCCESS = "MENU_ITEMS/DELETE_SUCCESS";
export const DELETE_FAILED = "MENU_ITEMS/DELETE_FAILED";

export const GET_REQUEST = "MENU_ITEMS/GET_REQUEST";
export const GET_SUCCESS = "MENU_ITEMS/GET_SUCCESS";
export const GET_FAILED = "MENU_ITEMS/GET_FAILED";

export const GET_AVG_COST_REQUEST = "MENU_ITEMS/GET_AVG_COST_REQUEST";
export const GET_AVG_COST_SUCCESS = "MENU_ITEMS/GET_AVG_COST_SUCCESS";
export const GET_AVG_COST_FAILED = "MENU_ITEMS/GET_AVG_COST_FAILED";

export const TABLE_UPDATE = "MENU_ITEMS/TABLE_UPDATE";

const types = {
    FETCH_REQUEST,
    FETCH_SUCCESS,
    FETCH_FAILED,

    CREATE_REQUEST,
    CREATE_SUCCESS,
    CREATE_FAILED,

    UPDATE_REQUEST,
    UPDATE_SUCCESS,
    UPDATE_FAILED,

    GET_REQUEST,
    GET_SUCCESS,
    GET_FAILED,

    DELETE_REQUEST,
    DELETE_SUCCESS,
    DELETE_FAILED,

    GET_AVG_COST_REQUEST,
    GET_AVG_COST_SUCCESS,
    GET_AVG_COST_FAILED,

    TABLE_UPDATE,
};

export default types;
